var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43551 12.6668H4.25986L11.1778 5.74888L10.3535 4.92451L3.43551 11.8425V12.6668ZM3.0381 13.6668C2.86631 13.6668 2.72294 13.6093 2.60798 13.4943C2.49302 13.3794 2.43555 13.236 2.43555 13.0642V11.6681C2.43555 11.5878 2.45007 11.5113 2.47913 11.4386C2.50819 11.366 2.55391 11.2984 2.61631 11.2361L10.5189 3.3335L12.6829 5.66934L4.86626 13.486C4.80387 13.5484 4.73636 13.5941 4.66371 13.6232C4.59106 13.6523 4.51456 13.6668 4.43421 13.6668H3.0381ZM10.7656 5.3367C10.6047 5.17573 10.3535 4.92451 10.3535 4.92451L11.1778 5.74888C11.1778 5.74888 10.9266 5.49766 10.7656 5.3367Z",
    fill: "#243B86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentEdit);
export default __webpack_public_path__ + "static/media/appointment-edit.fa53112c99cbcbce38622bdbcb19e73a.svg";
export { ForwardRef as ReactComponent };